import React, { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LOCAL_CONSTANT } from "../Const";

// スタイル付きのFormControlLabel
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    margin: 0,
    "& .MuiFormControlLabel-label": {
        fontSize: "14px",
        fontWeight: "bold", // 確認用に太字にする
    },
}));

export interface CompleteCheckBoxProps {
    props: {
        pageName: string; // 画面を識別するためのID（連動の制御用）
        checked: string; // チェック状態
        onChange: (
            event: React.ChangeEvent<HTMLInputElement>,
            id: string,
        ) => void; // 状態変更時のコールバック関数
        updateUser: string;
    };
}

const CompleteCheckBox: React.FC<CompleteCheckBoxProps> = ({ props }) => {
    // チェックボックスのチェック状態(0=false 1=true)
    const checked: boolean = props.checked === "0" ? false : true;

    // チェックボックスの変更ハンドラー
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(event, props.pageName);
    };

    // ユーザー情報
    const [userName, setUserName] = useState("");
    const [categoryName, setCategoryName] = useState("");
    useEffect(() => {
        const res: any = localStorage.getItem("staffMaster");
        if (res) {
            const staff = JSON.parse(res)?.find(
                (row: any) => row.staff_number === props.updateUser,
            );
            if (staff) {
                setUserName(staff.staff_name);
                setCategoryName("RR" + staff.job_category_name_oa);
            }
        }
    }, [props.updateUser]);

    return (
        <Box sx={{ width: "100%", display: "inline-block" }}>
            <Box sx={{ float: "right" }}>
                <Typography sx={{ textAlign: "right", fontWeight: "bold" }}>
                    完了チェック
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box sx={{ width: "100%" }}>
                        {checked && (
                            <Typography sx={{ fontSize: "0.9rem" }}>
                                {categoryName} : {userName}
                            </Typography>
                        )}
                    </Box>
                    <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        sx={{
                            "&.Mui-disabled": {
                                color: "#e0e0e0", // 無効時の色
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default CompleteCheckBox;
